export default __webpack_public_path__ + "static/html-css-cb9af9fd8651f09b4e5dec4ec0428f9d.webp";